import { render, staticRenderFns } from "./ScreenConfigureTrigger.vue?vue&type=template&id=32b7ea2f&scoped=true&"
import script from "./ScreenConfigureTrigger.vue?vue&type=script&lang=js&"
export * from "./ScreenConfigureTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b7ea2f",
  null
  
)

export default component.exports